<template>
  <div class="percent-circle">
    <div ref="container" style="width:100px;height:100px;"></div>
    <div class="percent-text">{{percent}}%</div>
  </div>
</template>

<script>
  import Echart from 'echarts'
  export default {
    props: {
      percent: {
        default: 80
      }
    },
    mounted () {
      this.refresh()
    },
    methods: {
      refresh () {
        let option = {
          tooltip: {
            show: false
          },
          legend: {
            show: false
          },
          toolbox: {
            show: false
          },
          color: ['#67CCFF', '#FD6766'],
          clickable: false,
          series: [
            {
              type: 'pie',
              silent: true,
              radius: ['80%', '100%'],
              itemStyle: {
                normal: {
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  }
                },
                emphasis: {
                  label: {
                    show: false
                  }
                }
              },
              data: [
                {value: this.percent},
                {value: 100 - this.percent}
              ]
            }
          ]
        }
        if (this.chart) {
          this.chart.dispose()
        }
        let chart = Echart.init(this.$refs.container)
        chart.setOption(option)
        this.chart = chart
      }
    },
    watch: {
      percent () {
        this.refresh()
      }
    }
  }
</script>
